import { log } from '@atlassian/mpac-utils';
import getSPI from '../services/SPI';
export const FETCH_HOST_PRICING = 'HOST_PRICING_FETCH_HOST_PRICING';
export const RECEIVE_HOST_PRICING = 'HOST_PRICING_RECEIVE_HOST_PRICING';
export const RECEIVE_HOST_PRICING_ERROR = 'HOST_PRICING_RECEIVE_HOST_PRICING_ERROR';
const fetchHostPricing = () => ({
  type: FETCH_HOST_PRICING
});
const receiveHostPricing = _ref => {
  let {
    hostPricing
  } = _ref;
  return {
    type: RECEIVE_HOST_PRICING,
    hostPricing
  };
};
const receiveHostPricingError = _ref2 => {
  let {
    error
  } = _ref2;
  return {
    type: RECEIVE_HOST_PRICING_ERROR,
    error
  };
};
export const doRetrieveHostPricing = fetchHostBillingSystemFromDemandServiceFlag => dispatch => {
  dispatch(fetchHostPricing());
  if (!getSPI().getHostPricingInfo) return;
  getSPI().getHostPricingInfo(fetchHostBillingSystemFromDemandServiceFlag).then(hostPricingInformation => {
    dispatch(receiveHostPricing({
      hostPricing: hostPricingInformation
    }));
  }, error => {
    log.error('HostPricing', "failed to retrieve host pricing : ".concat(error));
    dispatch(receiveHostPricingError({
      error
    }));
  });
};